import { render, staticRenderFns } from "./revenue-charge-record.vue?vue&type=template&id=3c55442d&scoped=true&"
import script from "./revenue-charge-record.vue?vue&type=script&lang=js&"
export * from "./revenue-charge-record.vue?vue&type=script&lang=js&"
import style0 from "./revenue-charge-record.vue?vue&type=style&index=0&id=3c55442d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55442d",
  null
  
)

export default component.exports